import { Box, HStack } from '@chakra-ui/react';
import GameGrid from '../components/game/GameGrid';
import GameHeading from '../components/game/GameHeading';
import GenreStrip from '../components/genre/GenreStrip';
import Platforms from '../components/platform/Platforms';
import SortSelector from '../components/common/SortSelector';

const HomePage = () => {
	return (
		<Box maxW="1600px" mx="auto" px={{ base: 3, md: 6 }} py={4}>
			<GameHeading />

			{/* Modern horizontal genre cards */}
			<Box mt={5} mb={4}>
				<GenreStrip />
			</Box>

			<HStack mb={5} gap={3} flexWrap="wrap">
				<Platforms />
				<SortSelector />
			</HStack>

			<GameGrid />
		</Box>
	);
};

export default HomePage;
